import { render, staticRenderFns } from "./BoxWithIcons.vue?vue&type=template&id=cdcf27ce&scoped=true&"
import script from "./BoxWithIcons.vue?vue&type=script&lang=js&"
export * from "./BoxWithIcons.vue?vue&type=script&lang=js&"
import style0 from "./BoxWithIcons.vue?vue&type=style&index=0&id=cdcf27ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf27ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdcf27ce')) {
      api.createRecord('cdcf27ce', component.options)
    } else {
      api.reload('cdcf27ce', component.options)
    }
    module.hot.accept("./BoxWithIcons.vue?vue&type=template&id=cdcf27ce&scoped=true&", function () {
      api.rerender('cdcf27ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BoxWithIcons.vue"
export default component.exports